export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10419.9d27897f.jpg";